'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.documentSelector = exports.inboxChildrenSelector = undefined;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _reselect = require('reselect');

var _milanoteReselect = require('../../utils/milanoteReselect/milanoteReselect');

var _mainSelector = require('../main/mainSelector');

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _gridSizeSelector2 = _interopRequireDefault(_gridSizeSelector);

var _elementHelper = require('../../../common/elements/elementHelper');

var _documentModeUtil = require('./algorithm/documentModeUtil');

var _boardConstants = require('../../../common/boards/boardConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var cleanElementMeta = function cleanElementMeta(element) {
    return element.delete('meta').delete('attachment');
};

// Constants


// Selectors


var canvasChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(_mainSelector.getCurrentChildren, function (children) {
    return children.filter(function (child) {
        return child.getIn(['location', 'section']) === _boardConstants.BOARD_SECTIONS.CANVAS;
    });
});

var inboxChildrenSelector = exports.inboxChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(_mainSelector.getCurrentChildren, function (children) {
    return children.filter(function (child) {
        return child.getIn(['location', 'section']) === _boardConstants.BOARD_SECTIONS.INBOX;
    }).sort(_elementHelper.sortByScore).toList();
});

var cleanCanvasChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(canvasChildrenSelector, function (children) {
    return children.filterNot(_elementHelper.isLine).map(cleanElementMeta);
});

var documentOrderSelector = (0, _milanoteReselect.createImmutableShallowSelector)(cleanCanvasChildrenSelector, function (canvasChildren) {
    var sizes = canvasChildren.map(function (child) {
        return {
            id: child.get('id'),
            width: 0,
            height: 0
        };
    }).toArray();

    var processedElements = (0, _documentModeUtil.calculateDocumentModeOrder)({ elements: canvasChildren, elementSizes: sizes });

    return Immutable.List(processedElements.order);
});

var documentOrderedChildrenSelector = (0, _milanoteReselect.createImmutableShallowSelector)(documentOrderSelector, canvasChildrenSelector, function (order, children) {
    return order.map(function (elementId) {
        return children.get(elementId);
    });
});

// TODO - Not sure if the grid size should really be passed through here, but just doing it as a POC
var documentSelector = exports.documentSelector = (0, _reselect.createSelector)(function (state, props) {
    return props.currentBoardId;
}, _gridSizeSelector2.default, documentOrderedChildrenSelector, inboxChildrenSelector, _mainSelector.getBreadcrumb, function (currentBoardId, gridSize, documentChildren, inboxChildren, breadcrumb) {
    return {
        orderedElements: documentChildren,
        inboxElements: inboxChildren,
        gridSize: gridSize,
        breadcrumb: breadcrumb
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/documentModeSelector.js
// module id = 786
// module chunks = 0